export const getInitials = (name: string | undefined | null) => {
  const trimmed = name?.trim();
  if (!trimmed) return undefined;
  const words = trimmed.split(/\s+/).filter((w) => w.length > 0);

  if (words.length === 0) return undefined;

  if (words.length === 1) {
    const firstChar = [...words[0]][0];
    return firstChar ? firstChar.toUpperCase() : undefined;
  }

  const firstChar = [...words[0]][0];
  const lastChar = [...words[words.length - 1]][0];

  if (!firstChar || !lastChar) return undefined;

  return (firstChar + lastChar).toUpperCase();
};
